<!-- 月度计划管理 -->
<template>
  <div>
    <!-- <matrix-statistics span="8" :list="infoCardData(cardData)"></matrix-statistics> -->
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-upload2" plain size="small" @click="onImport">导入</el-button>
        <el-button type="primary" icon="el-icon-download" plain size="small" :loading="exportLoading" @click="handleExport">导出</el-button>
        <el-button type="default" icon="el-icon-download" plain size="small" :loading="templateLoading" @click="handleTemplate">导入模板</el-button>
        <el-button type="danger" icon="el-icon-delete" plain size="small" :disabled="selectionList.length == 0" @click="handleDelete">批量删除</el-button>
      </template>
      <template slot-scope="{row,index}" slot="menu">
        <el-button size="small" type="text" @click="$refs.crud.rowView(row, index)">详情</el-button>
        <el-button size="small" type="text" @click="$refs.crud.rowEdit(row, index)">编辑</el-button>
        <el-button size="small" type="text" @click="$refs.crud.rowDel(row, index)">删除</el-button>
        <el-button size="small" type="text" @click="handleMaterials(row)">应急物资</el-button>
      </template>
    </avue-crud>
    <dialog-reset title="储备点导入" :visible.sync="excelBox" height="auto" width="650px">
      <avue-form :option="excelOption" v-model="excelForm" :upload-after="uploadAfter">
        <template slot="excelTemplate">
          <el-button type="primary" @click="handleTemplate">
            点击下载<i class="el-icon-download el-icon--right"></i>
          </el-button>
        </template>
      </avue-form>
    </dialog-reset>
    <el-dialog
      title="应急物资"
      :visible.sync="materialsDialogVisible"
      width="900px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-table :data="materialsList" border size="small" v-loading="materialsLoading" empty-text="暂无关联应急物资">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="materialName" label="应急物资名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="materialType" label="物资类型" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatMaterialType(scope.row.materialType) }}</template>
        </el-table-column>
        <el-table-column prop="currentStock" label="数量" width="100" align="right"></el-table-column>
        <el-table-column prop="unit" label="单位" width="90">
          <template slot-scope="scope">{{ formatUnit(scope.row.unit) }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="materialsDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, removeBatch, downloadImportTemplate, exportExcel, getMaterials } from "./api";
import { getDictionary } from "@/api/system/dictbiz";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";
import matrixStatistics from '@/components/matrix/matrix-statistics'
import { downloadXls } from '@/util/util'
export default {
  components: { matrixStatistics },
  mixins: [crudMixins],
  data () {
    const that = this
    return {
      form: {},
      excelForm: {},
      excelBox: false,
      templateLoading: false,
      exportLoading: false,
      materialsDialogVisible: false,
      materialsLoading: false,
      materialsList: [],
      materialTypeDicData: [],
      materialTypeDicLoaded: false,
      unitDicData: [],
      unitDicLoaded: false,
      apiConfig: { getList, add, update, remove, getDetail, batchRemove: removeBatch },
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "文件上传",
            prop: "excelFile",
            type: "upload",
            drag: true,
            loadText: "文件上传中，请稍等",
            showFileList: false,
            propsHttp: {
              res: "data",
            },
            tip: "请上传 .xls,.xlsx 标准格式文件",
            action: "/api/produce/emergency-storage-point/import-excel",
          },
          {
            label: "模板下载",
            prop: "excelTemplate",
            formslot: true,
          },
        ],
      },
      option: {
        ...this.$store.state.publicOption,
        searchDateProp: false,
        selection: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 260,
        column: [
          {
            label: '储备点编号',
            prop: 'pointCode',
            overHidden: true,
            minWidth: 120,
            search: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '储备点名称',
            prop: 'pointName',
            overHidden: true,
            minWidth: 150,
            maxlength: 100,
            search: true,
            rules: rulesInput(1),
          },
          {
            label: '储备点位置',
            prop: 'location',
            type: 'input',
            overHidden: true,
            minWidth: 180,
            maxlength: 255,
            search: true,
            placeholder: '请输入储备点位置',
            rules: rulesInput(1),
          },
          {
            label: '物资数量',
            prop: 'materialQuantity',
            type: 'number',
            precision: 0,
            min: 0,
            max: 999999,
            overHidden: true,
            width: 120,
            placeholder: '请输入物资数量',
            rules: rulesInput(2),
          },
          {
            label: '负责人名称',
            prop: 'personChargeName',
            overHidden: true,
            width: 120,
            type: 'input',
            maxlength: 50,
            search: true,
            placeholder: '请输入负责人姓名',
            rules: rulesInput(2),
          },
          {
            label: '负责人电话',
            prop: 'contactPhone',
            overHidden: true,
            width: 130,
            type: 'input',
            maxlength: 20,
            search: true,
            placeholder: '请输入联系电话',
            rules: [
              { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
            ],
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            overHidden: true,
            width: 100,
            dicData: [
              { label: '无效', value: 0 },
              { label: '有效', value: 1 },
            ],
            value: 1,
            rules: rulesInput(2),
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 500,
            span: 24,
            minRows: 3,
            hide: true,
          },
          {
            label: '录入人',
            prop: 'createName',
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: '录入时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig('', { type: 'datetimerange' }),
            searchValue: [],
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: '修改人',
            prop: 'updateName',
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true,
            width: 180,
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
        ]
      },
      defaultParams: {}
    }
  },
  computed: {
    infoCardData () {
      return function (cardData) {
        return [{
          label: '储备点总数',
          value: cardData['totalPoints'],
          unit: ' 个',
        }, {
          label: '物资总量',
          value: cardData['totalMaterials'],
          unit: ' 件',
        }, {
          label: '覆盖区域',
          value: cardData['coverageArea'],
          unit: ' 个',
        }] // 卡片数据
      }
    }
  },
  methods: {
    onImport() {
      this.excelBox = true;
    },
    uploadAfter(res, done) {
      if (!(res instanceof Error)) {
        this.$message.success("导入成功");
      }
      this.excelBox = false;
      this.onLoad(this.page, this.query);
      done();
    },
    async handleTemplate() {
      this.templateLoading = true;
      try {
        const res = await downloadImportTemplate();
        downloadXls(res.data, `储备点导入模板_${Date.now()}.xlsx`);
        this.$message.success("模板下载成功");
      } catch (e) {
        this.$message.error((e && e.message) || "模板下载失败");
      } finally {
        this.templateLoading = false;
      }
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `储备点_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
    async handleMaterials(row) {
      if (!row || !row.id) {
        this.$message.warning("请选择储备点");
        return;
      }
      this.materialsDialogVisible = true;
      this.materialsLoading = true;
      this.materialsList = [];
      try {
        await Promise.all([
          this.loadEmergencyMaterialTypeDic(),
          this.loadEmergencyUnitDic()
        ]);
        const res = await getMaterials(row.id);
        this.materialsList = (res.data && res.data.data) || [];
      } catch (e) {
        this.$message.error((e && e.message) || "加载应急物资失败");
      } finally {
        this.materialsLoading = false;
      }
    },
    loadEmergencyMaterialTypeDic() {
      if (this.materialTypeDicLoaded) {
        return Promise.resolve();
      }
      return getDictionary({ code: "emergency_materialType" }).then(res => {
        this.materialTypeDicData = (res.data && res.data.data) || [];
        this.materialTypeDicLoaded = true;
      }).catch(() => {
        this.materialTypeDicData = [];
        this.materialTypeDicLoaded = true;
      });
    },
    loadEmergencyUnitDic() {
      if (this.unitDicLoaded) {
        return Promise.resolve();
      }
      return getDictionary({ code: "emergency_unit" }).then(res => {
        this.unitDicData = (res.data && res.data.data) || [];
        this.unitDicLoaded = true;
      }).catch(() => {
        this.unitDicData = [];
        this.unitDicLoaded = true;
      });
    },
    formatMaterialType(value) {
      return this.formatDicLabel(this.materialTypeDicData, value);
    },
    formatUnit(value) {
      return this.formatDicLabel(this.unitDicData, value);
    },
    formatDicLabel(dicData, value) {
      if (value === undefined || value === null || value === "") {
        return "";
      }
      const match = dicData.find(item => {
        return String(item.dictKey) === String(value)
          || String(item.dictValue) === String(value)
          || String(item.value) === String(value)
          || String(item.label) === String(value);
      });
      return match ? (match.dictValue || match.label || value) : value;
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
</style>
